import { Spin } from 'antd';
import styled from 'styled-components';
import { SpinSize } from 'antd/lib/spin';

interface LoadingContainerProps {
  height?: number;
}

const LoadingContainer = styled.div<LoadingContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ height }) => (height ? `${height}px` : '100vh')};
`;

interface FullScreenLoadingProps {
  height?: number;
  size?: SpinSize;
}

export const HSMSLoading = ({ height, size }: FullScreenLoadingProps) => {
  return (
    <LoadingContainer data-testid="loading-screen" height={height}>
      <Spin size={size || 'large'} />
    </LoadingContainer>
  );
};
